module.exports = ".bubble {\n  background-color: #e2205b;\n  color: white;\n  width: 17px;\n  height: 17px; }\n  .bubble b {\n    position: relative;\n    top: -2px; }\n  .bubble .one-digit-position {\n    right: -5px; }\n  .bubble .two-digit-position {\n    right: -2px; }\n  .jumbotron {\n  overflow: initial; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/layouts/components/default/default.component.scss
// module id = ./libs/chassis-core/src/app/layouts/components/default/default.component.scss
// module chunks = main